import { useWorkspaceStore } from "../store/workspace/WorkspaceStore";
import { useMemo, useRef } from "react";
import { transformWorkspaceToCompanyFilter } from "../utils/workspace/transformWorkspaceToCompanyFilter";
import { Market } from "../types/workspace";
import { isEqual } from "../utils/jsUtils";
import { CompanyFilter } from "../legacy/types/companyFilter";

export function useCombinedFilters(workspaceFiltersOnly = false) {
  const selectedMarket =
    useWorkspaceStore((w) => w.selectedMarket) || Market.TAM;
  const draft = useWorkspaceStore((w) => w.draft);
  const userFilters = useWorkspaceStore((w) => w.userFilters);

  // Add reference stability at the source
  const prevResultRef = useRef<CompanyFilter | undefined>(undefined);

  return useMemo(() => {
    // In workspace-filters-only mode we drop ad-hoc user filters, but the
    // company type (GHQ / Corporate Parent / Domestic Parent) defines how
    // entities are counted, so it must still pass through to keep the
    // configuration-page charts consistent with the TAM/SAM/SOM cards.
    const effectiveUserFilters = workspaceFiltersOnly
      ? {
          isGhq: userFilters?.isGhq,
          isGp: userFilters?.isGp,
          isDp: userFilters?.isDp,
        }
      : userFilters;

    const newFilters = transformWorkspaceToCompanyFilter(
      selectedMarket,
      draft,
      effectiveUserFilters
    );

    // Use deep comparison to maintain reference stability
    if (isEqual(prevResultRef.current, newFilters)) {
      return prevResultRef.current;
    }

    // Update reference when content changes
    prevResultRef.current = newFilters;
    return newFilters;
  }, [selectedMarket, draft, userFilters, workspaceFiltersOnly]);
}
